import { httpClient as http } from '@/utils/http'

// API基础路径
const API_BASE = '/mdm/tradeTerms'

// 基础分页请求
export interface PageRequest {
  pageNum: number
  pageSize: number
}

// 分页结果
export interface PageResultVO<T> {
  records: T[]
  total: number
  pageNum: number
  pageSize: number
}

// 贸易条款分页查询请求
export interface TradeTermsPageRequest extends PageRequest {
  tenantId?: string
  termsCode?: string
  termsName?: string
  enabled?: number
  keyword?: string
}

// 贸易条款列表项视图对象
export interface TradeTermsListVO {
  id: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled: number
  isPlatformData?: boolean
}

// 贸易条款详情视图对象
export interface TradeTermsVO {
  id: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled: number
  isPlatformData?: boolean
}

// 贸易条款保存请求
export interface TradeTermsSaveRequest {
  id?: string
  tenantId?: string
  termsCode: string
  termsName: string
  enabled?: number
}

// 贸易条款更新请求
export interface TradeTermsUpdateRequest extends TradeTermsSaveRequest {
  id: string
}

// 模糊搜索请求
export interface FuzzySearchRequest {
  keyword: string
  enabled?: number
  tenantId?: string
}

// 查询平台数据请求
export interface QueryPlatformRequest {
  pageNum?: number
  pageSize?: number
  keyword?: string
  tenantId?: string
}

// 批量关联请求
export interface BatchAssociateRequest {
  platformIds: string[]
}

// 批量解除关联请求
export interface BatchDisassociateRequest {
  associationIds?: string[]
  platformIds?: string[]
}

// 更新状态请求
export interface UpdateStatusRequest {
  ids: string[]
  enabled: number
}

// 删除请求
export interface DeleteRequest {
  ids: string[]
}

// 贸易条款API
export const tradeTermsApi = {
  // 分页查询贸易条款列表
  page: (params: TradeTermsPageRequest) => {
    return http.post<PageResultVO<TradeTermsListVO>>(`${API_BASE}/queryPage`, params)
  },

  // 查询贸易条款列表
  list: (params: TradeTermsPageRequest) => {
    return http.post<TradeTermsListVO[]>(`${API_BASE}/queryList`, params)
  },

  // 模糊搜索贸易条款
  search: (params: FuzzySearchRequest) => {
    return http.post<TradeTermsListVO[]>(`${API_BASE}/search`, params)
  },

  // 根据ID获取贸易条款详情
  get: (id: string) => {
    return http.post<TradeTermsVO>(`${API_BASE}/getById`, { id })
  },

  // 保存贸易条款（新增或更新）
  save: (params: TradeTermsSaveRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 更新贸易条款
  update: (params: TradeTermsUpdateRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 删除贸易条款
  delete: (params: DeleteRequest) => {
    return http.post<boolean>(`${API_BASE}/delete`, params)
  },

  // 更新状态
  updateStatus: (params: UpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/updateStatus`, params)
  },

  // 批量更新状态
  batchUpdateStatus: (params: UpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/batchUpdateStatus`, params)
  },

  // 根据贸易条款代码查询
  getByCode: (code: string) => {
    return http.post<TradeTermsVO>(`${API_BASE}/getByCode`, { code })
  },

  // 查询启用状态的贸易条款
  queryEnabled: (params: TradeTermsPageRequest) => {
    return http.post<TradeTermsListVO[]>(`${API_BASE}/queryEnabled`, params)
  },

  // 查询可关联的平台贸易条款（分页）
  queryPlatformPage: (params: QueryPlatformRequest) => {
    return http.post<PageResultVO<TradeTermsListVO>>(`${API_BASE}/queryPlatformPage`, params)
  },

  // 查询可关联的平台贸易条款（列表）
  queryPlatformList: (params: QueryPlatformRequest) => {
    return http.post<TradeTermsListVO[]>(`${API_BASE}/queryPlatformList`, params)
  },

  // 批量关联平台贸易条款
  batchAssociate: (params: BatchAssociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchAssociate`, params)
  },

  // 批量解除关联平台贸易条款
  batchDisassociate: (params: BatchDisassociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchDisassociate`, params)
  }
}
